import React from "react";
function CreateTicket() {
  return (
    <div className="container py-5">
      <div className="row g-4">
        <h2 className="text-muted py-3">
          To create a ticket, select a relevant topic
        </h2>
        <div className="col-12 col-md-4 p-3 p-md-4">
          <h5 className="mb-3">
            <i className="fa-solid fa-circle-plus" aria-hidden="true"></i>
            &nbsp;Account Opening
          </h5>
          <a
            className="d-block py-2"
href="/support"
            style={{ textDecoration: "none" }}
          >
            Getting started
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Online
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Offline
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Charges
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Company, Partnership and HUF
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Non Resident Indian (NRI)
          </a>
        </div>
        <div className="col-12 col-md-4 p-3 p-md-4">
          <h5 className="mb-3">
            <i className="fa-regular fa-user"></i> &nbsp;Your Finovate Account
          </h5>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Login credentialsd
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Your Profiled
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Account modification
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            CMR & DP IDd
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Nominationd
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Transfer of sharesd
          </a>
        </div>
        <div className="col-12 col-md-4 p-3 p-md-4">
          <h5 className="mb-3">
            <i className="fa-solid fa-chart-simple"></i> &nbsp;Trading and
            Markets
          </h5>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Trading FAQs
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Kite
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Margins
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Product and order types
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Corporate actions
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Kite features
          </a>
        </div>
      </div>
      <div className="row g-4 mt-2">
        <div className="col-12 col-md-4 p-3 p-md-4">
          <h5 className="mb-3">
            <i className="fa-regular fa-credit-card"></i> &nbsp;Funds
          </h5>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Fund withdrawal
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Adding funds
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Adding bank accounts
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            eMandates
          </a>
        </div>
        <div className="col-12 col-md-4 p-3 p-md-4">
          <h5 className="mb-3">
            <i className="fa-solid fa-circle-notch"></i> &nbsp;Console
          </h5>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            IPO
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Portfolio
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Funds statement
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Reports
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Referral program
          </a>
        </div>
        <div className="col-12 col-md-4 p-3 p-md-4">
          <h5 className="mb-3">
            <i className="fa-solid fa-coins"></i> &nbsp;Coin
          </h5>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Understanding mutual funds
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Coin app
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Coin web
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            Transactions and reports
          </a>
          <a
            className="d-block py-2"
            href="/"
            style={{ textDecoration: "none" }}
          >
            National Pension Scheme (NPS)
          </a>
        </div>
      </div>
    </div>
  );
}

export default CreateTicket;
